module.exports = __webpack_public_path__ + "img/warning.d7595cc7.svg";